import { deepmerge } from '@mui/utils';

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          flexShrink: 0,
          boxShadow: 'none',
          UserSelect: 'none !important'
        },

        // Size specific styles
        // sizeSmall: {
        //   borderRadius: 4 // smaller radius for small buttons
        // },
        // sizeMedium: {
        //   borderRadius: 8 // medium radius for medium buttons
        // },
        // sizeLarge: {
        //   borderRadius: 10 // larger radius for large buttons
        // },

        // Contained inherit
        containedInherit: {
          color: theme.palette.grey[800],
          '&:hover': {
            backgroundColor: theme.palette.grey[400]
          }
        },
        // Outlined inherit
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        },
        // Outlined success
        outlinedSuccess: {
          border: `1px solid ${theme.palette.success.dark}`,
          color: theme.palette.success.dark,
          '&:hover': {
            backgroundColor: deepmerge(theme.palette.success.main, { alpha: 0.5 }) // Lighten on hover
          }
        },
        // Text inherit
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        }
      }
    }
  };
}
